import { atom } from 'jotai';

import type { Maintenance } from '../../context/MaintenanceProvider';

import {
  getDisablePaymentByPaymentMethod,
  getMaintenanceByPaymentMethod,
  getDisablePaymentMediumByPaymentMethod,
} from './getPaymentMethodsInMaintenance';

export const maintenanceInfoAtom = atom<Maintenance | undefined>(undefined);

export const hidePaymentMethodAtom = atom<boolean>(
  (get) => get(maintenanceInfoAtom)?.showMaintenance === true,
);

export const paymentMethodInMaintenanceAtom = atom<Maintenance[] | undefined>(
  undefined,
);

export const hideCreditCardAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'CreditCard',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenanceCreditCardAtom = atom<Maintenance | undefined>((get) =>
  getMaintenanceByPaymentMethod(
    'CreditCard',
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const hideFpxAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'Fpx',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenanceFpxAtom = atom<Maintenance | undefined>((get) =>
  getMaintenanceByPaymentMethod('Fpx', get(paymentMethodInMaintenanceAtom)),
);

export const hideThOnlineBankingAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'ThOnlineBanking',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenanceThOnlineBankingAtom = atom<Maintenance | undefined>(
  (get) =>
    getMaintenanceByPaymentMethod(
      'ThOnlineBanking',
      get(paymentMethodInMaintenanceAtom),
    ),
);

export const hidePromptPayAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'PromptPay',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenancePromptPayAtom = atom<Maintenance | undefined>((get) =>
  getMaintenanceByPaymentMethod(
    'PromptPay',
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const hideHkEWalletAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'HkEWallet',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenanceHkEWalletAtom = atom<Maintenance | undefined>((get) =>
  getMaintenanceByPaymentMethod(
    'HkEWallet',
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const hidePhOnlineBankingAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'PhOnlineBanking',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenancePhOnlineBankingAtom = atom<Maintenance | undefined>(
  (get) =>
    getMaintenanceByPaymentMethod(
      'PhOnlineBanking',
      get(paymentMethodInMaintenanceAtom),
    ),
);

export const hideIdOnlineBankingAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'IdOnlineBanking',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenanceIdOnlineBankingAtom = atom<Maintenance | undefined>(
  (get) =>
    getMaintenanceByPaymentMethod(
      'IdOnlineBanking',
      get(paymentMethodInMaintenanceAtom),
    ),
);

export const hidePayPalAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'PayPal',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenancePayPalAtom = atom<Maintenance | undefined>((get) =>
  getMaintenanceByPaymentMethod('PayPal', get(paymentMethodInMaintenanceAtom)),
);

export const hidePhEWalletAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'PhEWallet',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenancePhEWalletAtom = atom<Maintenance | undefined>((get) =>
  getMaintenanceByPaymentMethod(
    'PhEWallet',
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const hideIdEwalletAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'IdEWallet',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenanceIdEWalletAtom = atom<Maintenance | undefined>((get) =>
  getMaintenanceByPaymentMethod(
    'IdEWallet',
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const hideQrisAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'IdQr',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenanceQrisAtom = atom<Maintenance | undefined>((get) =>
  getMaintenanceByPaymentMethod('IdQr', get(paymentMethodInMaintenanceAtom)),
);
export const hidePayNowQrAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'PayNowQR',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenancePayNowQrAtom = atom<Maintenance | undefined>((get) =>
  getMaintenanceByPaymentMethod(
    'PayNowQR',
    get(paymentMethodInMaintenanceAtom),
  ),
);

const maintenanceIdOnlineBankingMediumAtom = atom<string[] | undefined>((get) =>
  getDisablePaymentMediumByPaymentMethod(get(maintenanceIdOnlineBankingAtom)),
);

const maintenancePhOnlineBankingMediumAtom = atom<string[] | undefined>((get) =>
  getDisablePaymentMediumByPaymentMethod(get(maintenancePhOnlineBankingAtom)),
);

const maintenanceThOnlineBankingMediumAtom = atom<string[] | undefined>((get) =>
  getDisablePaymentMediumByPaymentMethod(get(maintenanceThOnlineBankingAtom)),
);

export const maintenanceOnlineBankingMediumAtom = atom<string[] | undefined>(
  (get) => {
    const medium = [
      get(maintenanceIdOnlineBankingMediumAtom),
      get(maintenanceThOnlineBankingMediumAtom),
      get(maintenancePhOnlineBankingMediumAtom),
    ];
    return medium.find((m) => m !== undefined);
  },
);

const maintenanceIdEwalletMediumAtom = atom<string[] | undefined>((get) =>
  getDisablePaymentMediumByPaymentMethod(get(maintenanceIdEWalletAtom)),
);

const maintenancePhEwalletMediumAtom = atom<string[] | undefined>((get) =>
  getDisablePaymentMediumByPaymentMethod(get(maintenancePhEWalletAtom)),
);

const maintenanceHkEwalletMediumAtom = atom<string[] | undefined>((get) =>
  getDisablePaymentMediumByPaymentMethod(get(maintenanceHkEWalletAtom)),
);

export const maintenanceEWalletMediumAtom = atom<string[] | undefined>(
  (get) => {
    const medium = [
      get(maintenanceIdEwalletMediumAtom),
      get(maintenancePhEwalletMediumAtom),
      get(maintenanceHkEwalletMediumAtom),
    ];
    return medium.find((m) => m !== undefined);
  },
);

export const hideFpsAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'HkFps',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenanceFpsAtom = atom<Maintenance | undefined>((get) =>
  getMaintenanceByPaymentMethod('HkFps', get(paymentMethodInMaintenanceAtom)),
);

export const hidePhBnplAtom = atom<boolean>((get) =>
  getDisablePaymentByPaymentMethod(
    'PhBnpl',
    get(hidePaymentMethodAtom),
    get(paymentMethodInMaintenanceAtom),
  ),
);

export const maintenancePhBnplAtom = atom<Maintenance | undefined>((get) =>
  getMaintenanceByPaymentMethod('PhBnpl', get(paymentMethodInMaintenanceAtom)),
);
